import React from 'react';
import 'react-quill/dist/quill.snow.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import EmailTemplateFrom from './EmailTemplateFrom';
const CreateEmailTemplate = () => {
  return (
    <React.Fragment>
      <EmailTemplateFrom />
    </React.Fragment>
  );
};

export default CreateEmailTemplate;
